const pillars = [
  {
    icon: 'ri-lock-2-line',
    title: 'End-to-End Encryption',
    description:
      'All data passing through our VPN is wrapped in AES-256 encryption, the same standard trusted by governments and financial institutions globally.',
    color: 'bg-rose-50',
    img: 'https://public.readdy.ai/ai/img_res/f005061b5851ad15ad74436cc5b64024.jpg',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Zero-Log Policy',
    description:
      'We never store, track, or sell your browsing data. Our architecture is engineered to know as little about you as technically possible.',
    color: 'bg-emerald-50',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20mint%20green%20soft%20background%20with%20an%20eye%20with%20a%20diagonal%20line%20through%20it%2C%20privacy%20concept%2C%20Morandi%20pastel%20tones%2C%20minimalist%20art%2C%20no%20text%2C%20clean%20airy%20composition&width=400&height=300&seq=chiko-sec-2&orientation=landscape',
  },
  {
    icon: 'ri-scan-line',
    title: 'Threat Detection',
    description:
      'Our Cleaner app actively scans for malicious profiles, unauthorized configuration changes, and known threat signatures on your device.',
    color: 'bg-stone-100',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20light%20gray%20stone%20background%20with%20scanning%20radar%20circles%20and%20detection%20grid%20lines%2C%20soft%20Morandi%20palette%2C%20threat%20scanning%20concept%2C%20minimalist%20tech%20art%2C%20no%20text&width=400&height=300&seq=chiko-sec-3&orientation=landscape',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Automatic Updates',
    description:
      'Security is never static. Our apps receive silent, automatic security patches to stay ahead of emerging vulnerabilities without interrupting your workflow.',
    color: 'bg-amber-50',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20amber%20background%20with%20circular%20refresh%20and%20update%20arrows%2C%20Morandi%20warm%20tones%2C%20automatic%20system%20update%20concept%2C%20minimalist%20art%2C%20no%20text%2C%20clean%20soft%20composition&width=400&height=300&seq=chiko-sec-4&orientation=landscape',
  },
];

export default function SecuritySection() {
  return (
    <section id="security" className="py-24 md:py-32 bg-stone-100/60 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-16 gap-6">
          <div>
            <p className="text-xs text-stone-400 tracking-[0.3em] uppercase font-medium mb-4">Security Standards</p>
            <h2
              className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Your Privacy<br />
              <span className="italic font-normal text-stone-600">Is Non-Negotiable</span>
            </h2>
          </div>
          <p className="text-stone-500 text-sm max-w-sm leading-relaxed md:pt-12">
            Security is built into every layer of our products — not added as an afterthought. Here is how we protect you.
          </p>
        </div>

        {/* Four-column grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {pillars.map((p) => (
            <div key={p.title} className="rounded-3xl overflow-hidden bg-white flex flex-col">
              {/* Image */}
              <div className={`w-full h-44 overflow-hidden ${p.color}`}>
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Info */}
              <div className="p-6 flex flex-col gap-3 flex-1">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${p.icon} text-lg text-stone-700`} />
                </div>
                <h3 className="text-base font-semibold text-stone-900 leading-snug">
                  {p.title}
                </h3>
                <p className="text-xs text-stone-500 leading-relaxed">
                  {p.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats strip */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 border-t border-stone-200 pt-12">
          {[
            { value: 'AES-256', label: 'Encryption standard' },
            { value: '0 Logs', label: 'Data stored about you' },
            { value: '100%', label: 'Native iOS architecture' },
          ].map((s) => (
            <div key={s.label} className="flex flex-col gap-1">
              <span
                className="text-3xl font-bold text-stone-900"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {s.value}
              </span>
              <span className="text-xs text-stone-400 tracking-wide uppercase">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
